import { Alert, Group, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconClock } from "@tabler/icons-react";
import { useSignupCompletion } from "../../hooks/useSignupCompletion";

function PendingApprovalBanner() {
  const theme = useMantineTheme();
  const { user, userType } = useSignupCompletion();

  // Only show for BRAND_USER who are not approved
  if (userType !== "BRAND_USER" || user?.approved !== false) {
    return null;
  }

  return (
    <Alert color="yellow" radius={0} py={"xs"} mt={{ base: "sm", sm: 0 }}>
      <Stack gap="sm" hiddenFrom="sm">
        <Group align="flex-start" wrap="nowrap">
          <IconClock
            color={theme.colors.yellow[6]}
            size="1.2rem"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <div>
            <Text fw={700} c={"yellow"} size="sm">
              Account Pending Approval
            </Text>
            <Text size="xs" c="dimmed" mt={4}>
              Your brand account is currently under review. We'll notify you
              via email once approved. Thank you for your patience!
            </Text>
          </div>
        </Group>
      </Stack>

      <Group align="flex-start" wrap="nowrap" visibleFrom="sm">
        <IconClock
          color={theme.colors.yellow[6]}
          size="1.2rem"
          style={{ flexShrink: 0, marginTop: 2 }}
        />
        <div>
          <Text fw={700} c={"yellow"} size="sm">
            Account Pending Approval
          </Text>
          <Text size="xs" c="dimmed" mt={4}>
            Your brand account is currently under review. We'll notify you via
            email once approved. Thank you for your patience!
          </Text>
        </div>
      </Group>
    </Alert>
  );
}

export default PendingApprovalBanner;
